export default __webpack_public_path__ + "static/lutein_retina_bulb_sm-7249ee24806777f19b71cd5ad9ba1e6b.webm";